<template>
    <div class="padswipermar">
      <div class="swipe">
        <van-swipe :autoplay="3000" indicator-color="white" style="z-index:1;">
            <van-swipe-item><img src="@/assets/sw2.png" alt=""></van-swipe-item>
            <van-swipe-item><img src="@/assets/sw3.png" alt=""></van-swipe-item>
              <van-swipe-item><img src="@/assets/yingyong.png" alt=""></van-swipe-item>
        </van-swipe>
      </div>
    </div>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';
import Vue from 'vue';
import { Swipe, SwipeItem } from 'vant';

Vue.use(Swipe);
Vue.use(SwipeItem);
export default {
  data () {
    return {

    }
  },
  mounted(){

  },
  methods: {

  }

}
</script>

<style scoped>
.swipe{
  margin-top: 1.33333rem;
}
.swipe /deep/ .van-swipe{
  width: 100%;
  height: 2.95rem;
}
.van-swipe-item /deep/ {
  text-align: center;
}
img{
  width: 94%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Swipe.vue